__turbopack_context__.v({
  "companyTag": "CartHeaderSummary-module-scss-module__cA4uBa__companyTag",
  "summary": "CartHeaderSummary-module-scss-module__cA4uBa__summary",
  "tags": "CartHeaderSummary-module-scss-module__cA4uBa__tags",
  "when": "CartHeaderSummary-module-scss-module__cA4uBa__when",
  "whenLine": "CartHeaderSummary-module-scss-module__cA4uBa__whenLine",
  "whenText": "CartHeaderSummary-module-scss-module__cA4uBa__whenText",
});
